import { jsx as o, Fragment as L, jsxs as w } from "react/jsx-runtime";
import { useState as k, useMemo as v, useCallback as b, useLayoutEffect as y } from "react";
import t from "./styles.module.less.js";
import A from "./logo.webp.js";
import { usePathname as N } from "../../../utils/use-pathname.js";
import { AccountLink as C } from "./account-link/index.js";
import { FLOATING_CONTAINER_ID as m } from "./index.js";
import { areasOfLawData as I } from "../../../constants.js";
import { convertToKebabCase as D } from "../../../utils/case-conversion.js";
import { DropdownMenuItemDesktop as g } from "./dropdown-menu-item/index.js";
import { getAboutLinks as E } from "./get-about-links.js";
import { ForLawyersMenuButtonDesktop as M } from "./for-lawyers-button/index.js";
import { GetHelpMenuItemDesktop as S } from "./get-help-menu-item/index.js";
import { MenuChatButtonDesktop as R } from "./chat-button/index.js";
const $ = "/help", J = (n) => {
  const { getTranslation: r, language: e, isLawyerSupported: d = !1 } = n, a = N(), [i, f] = k(!1), c = v(() => {
    const s = I[e];
    if (s)
      return [
        ...s.map((u) => ({
          ...u,
          path: `/${e}/topics/${D(u.title)}`
        }))
      ];
  }, [e]), l = b(
    (s) => {
      switch (s) {
        case "/chat":
          return a === "/chat";
        case "/about":
          return a === `/${e}/about`;
        case "/help":
          return a === $;
        case "/topics":
          return a === `/${e}/topics`;
        case "/account":
          return a === "/account";
        case "/for-lawyers/legal-network":
          return a === `/${e}/for-lawyers/legal-network`;
        default:
          return !1;
      }
    },
    [a, c, e]
  );
  return y(() => {
    const s = () => {
      var p, h;
      (window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0) > 80 ? ((p = document.getElementById(m)) == null || p.classList.add(t.shrink), f(!0)) : ((h = document.getElementById(m)) == null || h.classList.remove(t.shrink), f(!1));
    };
    return window.addEventListener("scroll", s), document.body.addEventListener("scroll", s), s(), () => {
      window.removeEventListener("scroll", s), document.body.removeEventListener("scroll", s);
    };
  }, []), /* @__PURE__ */ o(L, { children: /* @__PURE__ */ o("div", { className: t.floatingContainer, id: m, children: /* @__PURE__ */ w("div", { className: t.menuContentContainer, children: [
    /* @__PURE__ */ o(
      "a",
      {
        href: e ? `/${e}` : "/",
        className: t.logoContainer,
        children: /* @__PURE__ */ o(
          "img",
          {
            src: A,
            alt: "LawConnect Logo",
            width: 0,
            height: 20,
            className: t.logo
          }
        )
      }
    ),
    /* @__PURE__ */ w("div", { className: t.menuLinksContainer, children: [
      d ? /* @__PURE__ */ o(
        S,
        {
          language: e,
          titleLabel: r("pages.get-help"),
          getTranslation: r,
          hasShrunk: i,
          isLawyerSupported: !0,
          onRequestLawyer: n.onRequestLawyer,
          isActive: l(
            "/help"
            /* HELP */
          )
        }
      ) : /* @__PURE__ */ o(
        R,
        {
          getTranslation: r,
          isScrolledHeader: i
        }
      ),
      d ? null : /* @__PURE__ */ o("div", { className: t.spacer }),
      c ? /* @__PURE__ */ o(
        g,
        {
          language: e,
          items: c,
          titleLabel: r("pages.topics"),
          hasShrunk: i,
          link: `/${e}/topics`,
          classNames: {
            container: t.subMenuContainer,
            itemRow: t.offsetDropdownItemRow
          },
          isActive: l(
            "/topics"
            /* KNOWLEDGE_BASE */
          )
        }
      ) : null,
      /* @__PURE__ */ o(
        g,
        {
          language: e,
          titleLabel: r("pages.about"),
          link: `/${e}/about`,
          hasShrunk: i,
          items: E({ language: e, getTranslation: r }),
          classNames: {
            container: t.subMenuContainer,
            itemRow: t.offsetDropdownItemRow
          },
          isActive: l(
            "/about"
            /* ABOUT */
          )
        }
      ),
      /* @__PURE__ */ o(
        M,
        {
          language: e,
          getTranslation: r,
          isScrolledHeader: i,
          isActive: l(
            "/for-lawyers/legal-network"
            /* FOR_LAWYERS */
          )
        }
      ),
      /* @__PURE__ */ o(
        C,
        {
          isScrolledHeader: i,
          isActive: l(
            "/account"
            /* ACCOUNT */
          ),
          isAuthenticated: n.isAuthenticated,
          userImage: n.userImage,
          openAuthModal: n.openAuthModal,
          logout: n.logout,
          hasNotifications: n.hasNotifications,
          language: e,
          getTranslation: r
        }
      )
    ] })
  ] }) }) });
};
export {
  J as DesktopMenu
};
